import React, { useState } from "react"
import ExternalLink from "@/public/icons/external-link.svg"

export const FeatureTab = ({ featureData = [], data: authorData }) => {
  return (
    <div className="title-info feature-info">
      {JSON.stringify(authorData, null, 4)}
    </div>
  )
}

export default FeatureTab
